'use strict';

module.exports = require('./lib/ReactScrolla');


//////////////////
// WEBPACK FOOTER
// /home/robin/Projects/react-scrolla/index.js
// module id = 648
// module chunks = 0